"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchInitialElements = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var sdk_model_1 = require("@gooddata/sdk-model");
var prepareElementsTitleQuery = function (appliedElements, backend, workspace, currentFilter, identifier) {
    var supportsElementUris = backend.capabilities.supportsElementUris;
    var isElementsByRef = sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(currentFilter));
    var options = {
        uris: appliedElements
            .map(function (element) {
            return supportsElementUris && isElementsByRef ? element.uri : element.title;
        })
            .filter(Boolean),
    };
    return backend
        .workspace(workspace)
        .attributes()
        .elements()
        .forDisplayForm(AttributeFilterUtils_1.getObjRef(currentFilter, identifier))
        .withOptions(options.uris.length > 0 ? options : {});
};
/**
 * Fetches data for the initial selection.
 */
exports.useFetchInitialElements = function (props) {
    var context = props.context, state = props.state, onFetchInitialElementsSuccess = props.onFetchInitialElementsSuccess, isElementsByRef = props.isElementsByRef;
    var filterObjRef = react_1.useMemo(function () { return AttributeFilterUtils_1.getObjRef(context.filter, context.identifier); }, [context.filter, context.identifier]);
    return sdk_ui_1.useCancelablePromise({
        promise: isEmpty_1.default(state.selectedFilterOptions)
            ? null
            : function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, prepareElementsTitleQuery(state.appliedFilterOptions, context.backend, context.workspace, context.filter, context.identifier).query()];
                });
            }); },
        onSuccess: function (initialElements) {
            onFetchInitialElementsSuccess(initialElements, isElementsByRef);
        },
    }, [
        context.backend,
        context.workspace,
        context.identifier,
        json_stable_stringify_1.default(filterObjRef),
        state.appliedFilterOptions,
    ]);
};
//# sourceMappingURL=useFetchInitialElements.js.map